import * as Sentry from '@sentry/browser';

export function initSentry(): void {
  // Skip in development
  if (import.meta.env.DEV) return;

  // Skip if DSN not configured
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: 'production',
    release: `web@${import.meta.env.VITE_APP_VERSION}`,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    initialScope: {
      tags: {
        service: 'web',
      },
    },
  });
}
